import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Feedback } from "components/feedback/Feedback";
import { Modal } from "components/modal/Modal";

class FeedbackPage extends Component {
  constructor (props) {
    super(props);
    
    this.state = {
      modalVisible: true
    };
  } 
  
  componentDidMount () {
    let {
      match,
      history
    } = this.props;
    
    if (!match.params.productId && !match.params.formId) {
      history.push("/");
    }
  }

  render () {
    let {
      match,
      history
    } = this.props;

    let formId,
        isProduct;

    if (!match.params.productId && !match.params.formId) return null;

    if (match.params.productId) {
      isProduct = true;
      formId = match.params.productId;
    } else {
      isProduct = false;
      formId = match.params.formId;
    }

    return (
      <div className={"p-2 p-lg-5"}>   
        <Helmet>
          <title>Minha Glambox : Feedback</title>
        </Helmet>
        <Modal visible={this.state.modalVisible} 
               useDefaultDialog={false} 
               showCloseButton={true}
               onCloseModal={this.toggleModal}>
          <Feedback 
            id={formId} 
            onFinish={this.finishFeedback}
            isProduct={isProduct}/>    
        </Modal>
      </div>
    );
  }

  toggleModal = () => {
    const {
      history
    } = this.props;

    this.setState({
      modalVisible: !this.state.modalVisible
    }, () => {
      history.push("/");
    });
  };
  
  finishFeedback = () => {
    this.toggleModal();
    this.setTimeout(() => {
      this.props.history.push("/");
    }, 300);
  };
}

export {
  FeedbackPage
};
